import client from '../../base-api';

const serviceURL = '/dashboard/head-of-psychosocial-services';

const dashboardHeadPsychosocialServicesService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },

    getUnitsDoneChart(filterData: any) {
        return client.get(`${serviceURL}/units-done-chart/${filterData?.year}/${filterData?.coachingType}/${filterData?.locationId}`);
    },

    getCoachDashboard(id: any) {
        return client.get(`${serviceURL}/coach-dashboard/${id}`);
    },

    getCoachUnitsDoneChart(filterData: any, coachId: any) {
        return client.get(`${serviceURL}/coach-units-done-chart/${filterData?.year}/${filterData?.coachingType}/${coachId}`);
    },

    getPotentialUnits(filterData: any) {
        return client.get(`${serviceURL}/potential-units`, {params: filterData});
    },

    getUnitsDonePerLocation(filterData: any) {
        return client.get(`${serviceURL}/units-done-per-location`, {params: filterData});
    },

    getUnsignedUnitsForLocation(filterData: any) {
        return client.get(`${serviceURL}/unsigned-units-for-location`, {params: filterData});
    },
}

export default dashboardHeadPsychosocialServicesService;